import { realUrlNow } from "@/lib/urlMask";
/* studioEngineFlag.js — which engine drives /studio's EDIT surface.
 *
 * DEFAULT = the original iframe (production behavior is UNCHANGED). The extracted
 * React configurator (frontend/src/configurator/*, parity-certified byte-identical:
 * serialization, validation, System-A pricing, geometry) is opt-in until soaked.
 *
 * Opt in / out (sticky, no rebuild):
 *   /studio/<id>?react=1   → use React (persists in localStorage)
 *   /studio/<id>?react=0   → back to the iframe (clears the flag)
 * Or set localStorage 'lhc-studio-react' = '1' | '0' directly.
 *
 * To make React the DEFAULT after soak: change DEFAULT_REACT to true (one line).
 */
const KEY = "lhc-studio-react";
// React is the DEFAULT /studio edit engine (parity-certified byte-identical: serialization,
// validation, System-A pricing, geometry, save round-trip). The original iframe remains a
// one-param fallback at /studio/<id>?react=0 until the HTML is deleted (Stage F).
const DEFAULT_REACT = true;

export function studioUsesReact() {
  try {
    const q = new URLSearchParams(realUrlNow().split("?")[1] || "");
    const r = q.get("react");
    if (r === "1") { localStorage.setItem(KEY, "1"); return true; }
    // 2026-07-19: ?react=0 is now PER-VISIT only. The sticky opt-out was a
    // soak-era mechanism — a stale stored "0" silently trapped users in the
    // iframe engine for every later visit (models→wizard→editor all legacy,
    // reported as "after wizard the configurator shows nothing"). The iframe
    // stays reachable for debugging via the URL param each time it's wanted.
    if (r === "0") { localStorage.removeItem(KEY); return false; }
    const v = localStorage.getItem(KEY);
    if (v === "0") localStorage.removeItem(KEY);   // clear stale opt-outs
    if (v === "1") return true;
    return DEFAULT_REACT;
  } catch (_) {
    return DEFAULT_REACT;
  }
}
